<template>
    <div class="Timesheet">
        <el-card class="box-card">
            <div class="mt-6   text-sm font-bold">
                <span v-if="active_tab_link == 'TODAY'">{{ moment(current_date).format('dddd, DD MMM YYYY') }}</span>
            </div>
             <!-- Summary data -->
             <div v-if="getTimesheetSummary" class="ns-summary-data mt-2 text-center">
                <el-row :gutter="10" class="flex justify-evenly" style="justify-content: space-evenly;">
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Labour Hours <br>
                            <span class="font-normal" style="font-size: 10px">(Schedule | Actual)</span>
                        <div class="mt-3 text-amplitude">
                            {{ getTimesheetSummary.scheduled_hours ? getTimesheetSummary.scheduled_hours + ' Hrs' : '0' }} |
                            {{ getTimesheetSummary.actual_hours ? getTimesheetSummary.actual_hours + ' Hrs' : '0' }}
                        </div>
                    </span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Labour Cost <br>
                            <span class="font-normal" style="font-size: 10px">(Schedule | Actual)</span>
                        <div class="mt-3 text-amplitude">
                            {{ getTimesheetSummary.scheduled_total_cost ? Math.round(getTimesheetSummary.scheduled_total_cost) + ' Hrs' : '0' }} |
                            {{ getTimesheetSummary.actual_total_cost ? Math.round(getTimesheetSummary.actual_total_cost) + ' Hrs' : '0' }}
                        </div>
                    </span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Leave 
                            <div class="mt-3 text-amplitude">
                                {{ getTimesheetSummary.leave_count ? getTimesheetSummary.leave_count : '0' }}
                            </div> 
                        </span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Weekly Off 
                            <div class="mt-3 text-amplitude">
                                {{ getTimesheetSummary.weekoff_count ? getTimesheetSummary.weekoff_count : '0' }}
                            </div> 
                        </span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Absent 
                            <div class="mt-3 text-amplitude">
                                {{ getTimesheetSummary.absent_count ? getTimesheetSummary.absent_count : '0'}}
                            </div> 
                        </span>
                    </el-col>
                    <!-- <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Overtime 
                            <div class="mt-3 text-amplitude">
                                {{ getTimesheetSummary.overtime_count }}
                            </div> 
                        </span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Late 
                            <div class="mt-3 text-amplitude">
                                {{ getTimesheetSummary.late_count }}
                            </div> 
                        </span>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="3" :xl="3" class="my-2">
                        <span class="text-sm font-semibold"> Early Out 
                            <div class="mt-3 text-amplitude">
                                {{ getTimesheetSummary.early_left_count }}
                            </div> 
                        </span>
                    </el-col> -->
                </el-row>
            </div>
            <!-- Summary data -->
        </el-card>

        <!-- <div class="mt-4 mb-4 ml-6 text-sm font-bold">
            <span v-if="active_tab_link == 'TODAY'">{{ moment(current_date).format('dddd, DD MMM YYYY') }}</span>
        </div>

        <div class="summary-section">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-card class="box-card" style="min-height: 140px;">
                        <table class="summary-table">
                            <tr>
                                <th>&nbsp;</th>
                                <th>Labour Hours</th>
                                <th>Labour Cost</th>
                            </tr>

                            <tr>
                                <td>Scheduled</td>
                                <td>{{ getTimesheetSummary.scheduled_labour_hours ? getTimesheetSummary.scheduled_labour_hours + ' Hrs' : 'NA' }}</td>
                                <td>{{ getTimesheetSummary.scheduled_labour_cost ? 'INR ' + getTimesheetSummary.scheduled_labour_cost : 'NA' }}</td>
                            </tr>

                            <tr>
                                <td>Actual</td>
                                <td>{{ getTimesheetSummary.actual_labour_hours ? getTimesheetSummary.actual_labour_hours + ' Hrs' : 'NA' }}</td>
                                <td>{{ getTimesheetSummary.actual_labour_cost ? 'INR ' + getTimesheetSummary.actual_labour_cost : 'NA' }}</td>
                            </tr>
                        </table>
                    </el-card>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mb-2">
                                <el-card class="box-card text-center" style="width: 80%; margin: 0 auto;">
                                    <div style="font-size: 12px; font-weight: 600; color: #848484;">Leave</div>

                                    <div style="font-size: 12px; font-weight: 600; color: #000; margin-top: 10px;">{{ getTimesheetSummary.total_leaves ? getTimesheetSummary.total_leaves : 'NA' }}</div>
                                </el-card>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mb-2">
                                <el-card class="box-card text-center" style="width: 80%; margin: 0 auto;">
                                    <div style="font-size: 12px; font-weight: 600; color: #848484;">Absent</div>

                                    <div style="font-size: 12px; font-weight: 600; color: #000; margin-top: 10px;">{{ getTimesheetSummary.total_absents ? getTimesheetSummary.total_absents : 'NA' }}</div>
                                </el-card>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mb-2">
                                <el-card class="box-card text-center" style="width: 80%; margin: 0 auto;">
                                    <div style="font-size: 12px; font-weight: 600; color: #848484;">Late</div>

                                    <div style="font-size: 12px; font-weight: 600; color: #000; margin-top: 10px;">{{ getTimesheetSummary.total_late ? getTimesheetSummary.total_late : 'NA' }}</div>
                                </el-card>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mb-2">
                                <el-card class="box-card text-center" style="width: 80%; margin: 0 auto;">
                                    <div style="font-size: 12px; font-weight: 600; color: #848484;">Weekly Off</div>

                                    <div style="font-size: 12px; font-weight: 600; color: #000; margin-top: 10px;">{{ getTimesheetSummary.total_weekly_off ? getTimesheetSummary.total_weekly_off : 'NA' }}</div>
                                </el-card>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mb-2">
                                <el-card class="box-card text-center" style="width: 80%; margin: 0 auto;">
                                    <div style="font-size: 12px; font-weight: 600; color: #848484;">Overtime</div>

                                    <div style="font-size: 12px; font-weight: 600; color: #000; margin-top: 10px;">{{ getTimesheetSummary.total_overtime ? getTimesheetSummary.total_overtime + ' Hrs' : 'NA' }}</div>
                                </el-card>
                            </el-col>

                            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="mb-2">
                                <el-card class="box-card text-center" style="width: 80%; margin: 0 auto;">
                                    <div style="font-size: 12px; font-weight: 600; color: #848484;">Early Out</div>

                                    <div style="font-size: 12px; font-weight: 600; color: #000; margin-top: 10px;">{{ getTimesheetSummary.total_early_out ? getTimesheetSummary.total_early_out : 'NA' }}</div>
                                </el-card>
                            </el-col>
                    </el-row>
                </el-col>
            </el-row>

        </div> -->

        <el-card class="box-card mt-4 ns-ts-day-tbl">
            <div class="action-bar">
               <div class="flex items-center">
                <div>
                    <p class="input-label">Location</p>
                    <el-select
                        v-model="selected_store"
                        placeholder="Select location"
                        filterable
                        style="width: 300px;"
                        size="medium"
                        class="location-drop-down"
                        @change="selectStorename()"
                    >
                        <el-option
                            v-for="(item, store_list_index) in store_list"
                            :key="store_list_index"
                            :value="item.id"
                            :label="item.name"
                            style="text-transform: capitalize;"
                        >
                            {{ item.name }}
                        </el-option>
                    </el-select>
                </div>

                <div  class="ml-6 flex">
                    <div>
                        <p class="input-label">{{ select_date_label }}</p>
                        <el-date-picker
                            :key="picker_type"
                            v-model="select_week" 
                            :type="picker_type"
                            size="medium"
                            :placeholder="select_date_label"
                            style="width: 250px !important;"
                            :clearable="false"
                            :format="picker_type === 'week' ? picker_format : ''"
                            :picker-options="date_range_options"
                            @change="showDayOfWeek()"
                        >
                        </el-date-picker> 
                    </div> 
                </div>
                <div class="ml-6">
                    <label>&nbsp;</label>
                    <el-button size="medium" class="action-btn" @click="loadApis()">Go</el-button>
                </div>
               </div>

                <div  class="ml-6 flex pt-3">
                    <el-input v-model="search_emp_by_id_name" clearable class="mx-5 " placeholder="Search by employee name and id"
                    style="width: 350px"></el-input> 

                    <el-button size="medium" icon="el-icon-download" class="action-btn " @click="exportCSV()">Export CSV</el-button>
                </div> 
            </div>

            <ManageTimeSheetV2 :selected-store="selected_store" :search-emp="search_emp_by_id_name" :store-list="store_list" :start-date="String(start_date)" :end-date="String(end_date)" :searched-employee="search_employee"></ManageTimeSheetV2>

             
        </el-card>

        <!-- <el-card class="box-card mt-4">
            <div v-if="active_tab_link == 'TODAY'" class="mt-8">
                <TodayTimeSheet :selected-store="selected_store" :searched-employee="search_employee"></TodayTimeSheet>
            </div>

            <div  class="mt-8">
                <ManageTimeSheet :selected-store="selected_store" :start-date="String(start_date)" :end-date="String(end_date)" :searched-employee="search_employee"></ManageTimeSheet>
            </div>
        </el-card> -->
    </div>
</template>

<script>
import moment from 'moment';
import LabourPalnningService from "../../../services/labourPalnningService";
import TodayTimeSheet from "./TodayTimeSheet";
import TodayTimeSheetV2 from "../../UI/sections/TodayTimeSheet.vue"
import ManageTimeSheetV2 from "../../UI/sections/ManageTimeSheet.vue"
import ManageTimeSheet from "./ManageTimeSheet";
import { EventBus } from "../../../eventBus";

export default {
    name: 'Timesheet',
    components: {
        TodayTimeSheet,
        ManageTimeSheet,
        TodayTimeSheetV2,
        ManageTimeSheetV2
    },
    data() {
        return {
            active_tab_link: 'TODAY',
            select_week: moment(),
            current_date: moment(),
            start_date: '',
            end_date: '',
            // start_date: moment().subtract(5,'d').format('YYYY-MM-DD'),
            // end_date: moment().subtract(1,'d').format('YYYY-MM-DD'),
            selected_store: '',
            search_employee: '',
            search_emp_by_id_name: '',
            picker_type: 'date',
            select_date_label: 'Select Date',
            picker_format: 'yyyy-MM-dd',
            date_range_options: {
				firstDayOfWeek: 1,
                cellClassName: function(d){
                },
                shortcuts: [
                    {
                        text: 'Day',
                        onClick: () => {
                            this.selectedShortcut('day');
                            this.select_week = new Date();
                            this.select_date_label = 'Select Date';
                        },
                    },
                    {
                        text: 'Week',
                        onClick: () => {
                            this.selectedShortcut('week');
                            this.select_week = new Date();
                            this.select_date_label = 'Select Week';
                        },
                    },
                    {
                        text: 'Month',
                        onClick: () => {
                            this.selectedShortcut('month');
                            this.select_week = new Date();
                            this.select_date_label = 'Select Month';
                        },
                    },
                    {
                        text: 'Custom',
                        onClick: () => {
                            this.selectedShortcut('custom');
                            this.select_week = '';
                            this.select_date_label = 'Select Custom Dates';
                        },
                    },
                ],
            },
            store_list: [],
            moment: moment
        }
    },
    computed: {
        getTimesheetSummary(){
            return this.$store.state.timesheet_summary;
        }
    },

    mounted(){
        this.getStoreList();
        this.showDayOfWeek();
        // Check store selection
        const globalStore = localStorage.getItem('store');
        if(globalStore){
            this.selected_store = globalStore;
        }
    },
    methods: {
        selectedShortcut(selected) {
            // Return the type based on the selected shortcut
            if (selected === 'day') {
                this.picker_type = 'date';
                this.picker_format = 'yyyy-MM-dd';
            } else if (selected === 'week') {
                this.picker_type = 'week';
                this.picker_format = 'yyyy-MM-dd';
            } else if (selected === 'month') {
                this.picker_type = 'month';
                this.picker_format = 'MM';
            } else if (selected === 'custom') {
                this.picker_type = 'daterange';
                this.picker_format = 'yyyy-MM-dd';
            } else {
                // Default to Week if no valid option selected
                this.picker_type = 'week';
                this.picker_format = 'yyyy-MM-dd';
            }
            },
        setActiveTabLink(link){
			if(link == 'TODAY'){
				this.active_tab_link = 'TODAY'
			}else{
				this.active_tab_link = 'TIMESHEETS'
			}

            // this.search_employee = '';
            // this.start_date = moment().subtract(5,'d').format('YYYY-MM-DD');
            // this.end_date = moment().subtract(1,'d').format('YYYY-MM-DD');
            // this.selected_store = '';
            this.select_week = new Date();
            this.showDayOfWeek();
        },

        selectStorename() {
			localStorage.setItem("store", this.selected_store);
		},

        // api to get store list
		getStoreList() {
			LabourPalnningService.getAllStoreData().then(response => {
				if (response.status == 200) {
					let all_store_list = JSON.parse(response.data);
					this.store_list = all_store_list.filter(e => {
						if (e.type == "store") {
							return e;
						}
					});

					this.store_list.sort((a, b) =>
						a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                    ); // sort a-z store list

                    if(!localStorage.getItem("store")){
                        this.selected_store = this.store_list[0].id;
                    }

                    // let selectStore = localStorage.getItem("store");

					// if (selectStore) {
					// 	this.selected_store = selectStore;
					// }

				} else {
					this.store_list = [];
				}
			});
		},

        loadApis(){
            EventBus.$emit('loadAllApis');
        },
        exportCSV(){
            EventBus.$emit('exportCSV');
        },

        showDayOfWeek() {
			let date = "";

            // this.select_week = new Date();
            date = this.select_week;

            if(this.picker_type === 'week') {
                var dt = new Date(date); // current date of week
                var currentWeekDay = dt.getDay();
                var lessDays = currentWeekDay === 0 ? 6 : currentWeekDay - 1;
                var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));

                let wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));

                this.start_date = moment(wkStart).format("YYYY-MM-DD");
                this.end_date = moment(wkEnd).format("YYYY-MM-DD");
                this.picker_format = `${this.start_date} To ${this.end_date}`;

            } else if(this.picker_type === 'month'){
                const currentDate = moment(date);
                this.start_date = currentDate.startOf('month').format("YYYY-MM-DD");
                this.end_date = currentDate.endOf('month').format("YYYY-MM-DD");
            } else if(this.picker_type === 'date'){
                const currentDate = moment(date);
                this.start_date = currentDate.format("YYYY-MM-DD");
                this.end_date = this.start_date ;
            } else if(this.picker_type === 'daterange'){
                console.log(date, 'datedate')
                this.start_date = moment(date[0]).format("YYYY-MM-DD");
                this.end_date = moment(date[1]).format("YYYY-MM-DD");
            }

		},
    },
}
</script>
<style lang="scss" scoped>
.Timesheet{
    .sub-menu-section{
        display: flex;
        width: 100%;
        align-items: center;
    }
    .tab-link {
        font-size: 0.9rem;
        padding: 0 0 5px 0;
        margin: 0 30px 0 0;
    }
    .active-tab-link {
        font-size: 0.9rem;
        color: #E29D5A;
        border-bottom: 2px solid #E29D5A;
    }
    label{
        display: block;
        font-size: 0.8rem;
        font-weight: bold;
        margin-bottom: 5px;
    }
    .action-bar{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .action-btn {
        background-color: #e29d5a;
        border-color: #e29d5a;
        color: #fff;
    }

    .summary-table{
        width: 100%;
        th{
            color: #848484;
            font-size: 12px;
            font-weight: 600;
            padding: 0px 10px 10px 10px;
        }

        td{
            font-size: 12px;
            padding: 15px;
            color: #000;
            font-weight: 600;
            text-align: center;
        }

        td:first-child{
            color: #848484;
            font-weight: 600;
        }
    }
}
</style>
<style lang="scss">
.Timesheet{
    .summary-section{
        .el-card__body{
            padding: 12px;
        }
    }

    .location-drop-down .el-input__inner{
        text-transform: capitalize!important;
    }
    .ns-ts-day-tbl{
        height: 72.5vh;
    }
}
</style>
